// import React from "react";
// import { Avatar, Layout, Menu } from "antd";
// import {
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
//   DashboardOutlined,
// } from "@ant-design/icons";
// import './SlideMenu.css';

// const { Sider } = Layout;

// const ModernSidebar = ({
//   collapsed,
//   setCollapsed,
//   items,
//   openKeys,
//   onOpenChange,
//   onClickMenu,
//   selectedKeys,
// }) => {
//   return (
//     <Sider
//       collapsible
//       collapsed={collapsed}
//       onCollapse={(value) => setCollapsed(value)}
//       width={265}
//       className="gradient-sidebar"
//       style={{
//         boxShadow: "4px 0 25px rgba(79, 70, 229, 0.15)",
//         borderRight: "none",
//       }}
//       trigger={null}
//     >
//       {/* ================================================================ */}
//       {/* LOGO AREA - Premium Design */}
//       {/* ================================================================ */}
//       <div
//         style={{
//           padding: collapsed ? "22px 18px" : "26px 22px",
//           display: "flex",
//           alignItems: "center",
//           gap: 14,
         
//         }}
//       >
//      <div
//         style={{
       
//           padding: collapsed ? "0px 0 0px 0" : "0px 0px 0px 0px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: collapsed ? 0 : 2,
//           borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
//           transition: "all 0.2s ease",
//         }}
//       >
//         {/* Responsive Brand Avatar */}
//         <Avatar 
//           src={'https://datacenterapi.votmean.app/photo/hmis_staff/file_image_logo-1763183005047-108934296'}
//           size={collapsed ? 40 : 60}
//           icon={<DashboardOutlined />}
//           style={{
//             border: "2px solid rgba(255, 255, 255, 0.2)",
//             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
//             background: "rgba(255, 255, 255, 0.05)",
//             transition: "all 0.2s ease",
//           }}
//         />

        
        
//       </div>

//         {/* Brand Name */}
//         {!collapsed && (
//           <div style={{ lineHeight: 1.2 }}>
//             <div
//               style={{
//                 fontWeight: 800,
//                 fontSize: 17,
//                 color: "Green",
//                 fontFamily: "'Content', 'Inter', sans-serif",
//                 letterSpacing: "-0.3px",
//               }}
//             >
//              វត្តមាន Votmean
//             </div>
//             <div
//               style={{
//                 paddingTop:5,
//                 fontSize: 10.5,
//                 color: "rgba(8, 120, 47, 0.7)",
//                 fontWeight: 'bold',
//                 fontFamily: "'Content', 'Inter', sans-serif",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               Data Center
//             </div>
//           </div>
//         )}

   
//       </div>

//       {/* ================================================================ */}
//       {/* COLLAPSE TOGGLE - Sleek Design */}
//       {/* ================================================================ */}
//       <div
//         style={{
         
//           display: "flex",
//           justifyContent: collapsed ? "center" : "flex-end",
//         }}
//       >
      
//       </div>

//       {/* ================================================================ */}
//       {/* BEAUTIFUL MENU */}
//       {/* ================================================================ */}
//       <div style={{ padding: "0 10px" }}>
//         <Menu
//           className="gradient-menu"
//           mode="inline"
//           theme="dark"
//           selectedKeys={selectedKeys}
//           defaultSelectedKeys={["1"]}
//           openKeys={openKeys}
//           onOpenChange={onOpenChange}
//           onClick={onClickMenu}
//           items={items}
//           style={{
//             background: "transparent",
//             borderRight: "none",
//             fontFamily: "'Content', 'Inter', 'Noto Sans Khmer', sans-serif",
//           }}
//         />
//       </div>

//       {/* ================================================================ */}
//       {/* SIDEBAR FOOTER - Subtle */}
//       {/* ================================================================ */}
//       {!collapsed && (
//         <div
//           style={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             padding: "14px 20px",
//             borderTop: "1px solid rgba(255, 255, 255, 0.1)",
//             textAlign: "center",
//             background: "linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.1))",
//           }}
//         >
//           <div
//             style={{
//               fontSize: 10,
//               color: "rgba(255, 255, 255, 0.5)",
//               fontFamily: "'Content', 'Inter', sans-serif",
//               fontWeight: 500,
//               letterSpacing: "0.3px",
//             }}
//           >
//             © 2024 Votmean Mobile
//           </div>
//         </div>
//       )}
//     </Sider>
//   );
// };

// export default ModernSidebar;


import React from "react";
import { Avatar, Layout, Menu } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import './SlideMenu.css';

const { Sider } = Layout;

const ModernSidebar = ({
  collapsed,
  setCollapsed,
  items,
  openKeys,
  onOpenChange,
  onClickMenu,
  selectedKeys,
}) => {
  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      width={265}
      className="gradient-sidebar"
      style={{
        boxShadow: "4px 0 25px rgba(79, 70, 229, 0.15)",
        borderRight: "none",
      }}
      trigger={null}
    >
      {/* ================================================================ */}
      {/* LOGO AREA - Premium Design */}
      {/* ================================================================ */}
      <div
        style={{
          padding: collapsed ? "22px 18px" : "26px 22px",
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
      >
        <div
          style={{
            padding: collapsed ? "0px 0 0px 0" : "0px 0px 0px 0px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: collapsed ? 0 : 2,
            borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
            transition: "all 0.2s ease",
          }}
        >
          {/* Responsive Brand Avatar */}
          <Avatar 
            src={'https://datacenterapi.votmean.app/photo/hmis_staff/file_image_logo-1763183005047-108934296'}
            size={collapsed ? 40 : 60}
            icon={<DashboardOutlined />}
            style={{
              border: "2px solid rgba(255, 255, 255, 0.2)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              background: "rgba(255, 255, 255, 0.05)",
              transition: "all 0.2s ease",
            }}
          />
        </div>

        {/* Brand Name */}
        {!collapsed && (
          <div style={{ lineHeight: 1.2 }}>
            <div
              style={{
                fontWeight: 800,
                fontSize: 17,
                color: "Green",
                fontFamily: "'Content', 'Inter', sans-serif",
                letterSpacing: "-0.3px",
              }}
            >
             វត្តមាន VOTMEAN
            </div>
            <div
              style={{
                paddingTop: 5,
                fontSize: 10.5,
                color: "rgba(8, 120, 47, 0.7)",
                fontWeight: 'bold',
                fontFamily: "'Content', 'Inter', sans-serif",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              Data Center
            </div>
          </div>
        )}
      </div>

      {/* ================================================================ */}
      {/* BEAUTIFUL NAVIGATION MENU */}
      {/* ================================================================ */}
      <div style={{ padding: "0 10px" }}>
        <Menu
          className="gradient-menu"
          mode="inline"
          theme="light" // FIX: Swapped to light mode theme matching SlideMenu.css targets
          selectedKeys={selectedKeys}
          defaultSelectedKeys={["1"]}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          onClick={onClickMenu}
          items={items}
          style={{
            background: "transparent",
            borderRight: "none",
            fontFamily: "'Content', 'Inter', 'Noto Sans Khmer', sans-serif",
          }}
        />
      </div>

      {/* ================================================================ */}
      {/* SIDEBAR FOOTER */}
      {/* ================================================================ */}
      {!collapsed && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "14px 20px",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            textAlign: "center",
            background: "linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.1))",
          }}
        >
          <div
            style={{
              fontSize: 10,
              color: "rgba(255, 255, 255, 0.5)",
              fontFamily: "'Content', 'Inter', sans-serif",
              fontWeight: 500,
              letterSpacing: "0.3px",
            }}
          >
            © 2024 Votmean Mobile
          </div>
        </div>
      )}
    </Sider>
  );
};

export default ModernSidebar;